define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-style",
	"dijit/_WidgetBase",
	"csi",
	"csi/_base/underscore",
	"csi/html",
	"csi/types",
    "csi/widget/FusionChartsLoader",
	"csi/widget/FusionChartUtil"
], function(declare,lang,domStyle,_WidgetBase,csi,_,html,types,FusionCharts,FusionChartUtil) {

	var DEFAULT_SETTINGS = {
		// Chart type
		chartType: "MSColumn2D",

		// Width and height of each chart
		chartWidth: 400,
		chartHeight: 300
	};

	var Widget = declare(_WidgetBase, {
		// String: metric key to be shown in graphs
		metricKey: null,

		// Object: various settings for charts
		settings: DEFAULT_SETTINGS,

		// SlicerDataAccess
		slicerDataAccess: null,

		// Array of FusionChart
		_fusionCharts: null,

		_oldData: {},

		_renderCharts: function() {
			// summary: render charts of the given type for the given metric
			var settings = this.get("settings");
			var metricKey = this.get("metricKey");

			if (!metricKey || !settings)
				return;

			if((this._fusionCharts && this._fusionCharts.length) && _.isEqual(this._oldData,{settings: settings, metricKey: metricKey})) {
				return;
			}

			this._oldData.settings = settings;
			this._oldData.metricKey = metricKey;

			settings = lang.delegate(DEFAULT_SETTINGS, settings);

			this._deleteChartNodes();

        	this._fusionCharts = [];
        	this.chartsDataArray = [];

        	var metricKeyGraph = this.slicerDataAccess.getGraphs(metricKey);

			_.forEach(metricKeyGraph, function(graphData, graphDataIndex) {
				var chartNode = html.create("div", {
					"class": "csi-fusion-chart"
				}, this.domNode);

				domStyle.set(chartNode, "height", this.chartHeight + "px");

				var chartData = {
					chart:{
						caption: graphData.getName(),
						xaxisname: graphData.getXAxisName(),
						yaxisname: graphData.getYAxisName(),
						animation: "0",
						showValues: "0",
						showPercentageValues: "0",
						"theme": 'centrictheme'
					}
				};

				if (this.slicerWidget){ // Old Slicer compatibility, old slicer does not define slicerWidget and getSpec method
					var spec = this.slicerWidget.getSpec(this.metricKey);
					var format = spec && spec.format;
					FusionChartUtil._addNumberFormatting(chartData.chart, format);
				}

				var labels = _.map(graphData.getXLabels(), function(v) {
					return {label: v};
				});

				var dataset = [];
				var graphDataSeries;

                try {
                    graphDataSeries = graphData.getSeries();
                } catch(err) {
                    console.warn("chart"+this.id+graphDataIndex+' did not render -- '+err);
                    domStyle.set(chartNode, "display", "none");
                }

				_.forEach(graphDataSeries, function(p){
					var series = {"seriesname": p.getName()};
					var data = p.getData();
					series.data = data;
					dataset.push(series);
				});

				chartData.categories = [{category:labels}];
				chartData.dataset = dataset;

		        this.chartsDataArray.push({
		        	chartData: chartData,
		        	chartNode: chartNode,
		        	chartId: "chart"+this.id+graphDataIndex
		        });

			}, this);

			this._createCharts(this.chartsDataArray,settings);
			this.chartsDataArray = [];
		},

		_createCharts: function(obj,settings) {
			_.each(obj,function(val){
				// we no longer support 3D charts, so replace with 2D variant
				var chartType = settings.chartType.replace(/3D/, "2D").toLowerCase();
				var fusionChart = new FusionCharts({
					id: val.chartId,
					type: chartType,			// FusionCharts has issue with uppercase names from past, so force to lowercase
					height: settings.chartHeight,
					width: settings.chartWidth,
					dataFormat: 'json',
					dataSource: val.chartData,
					renderAt: val.chartNode,

					events: {
						"rendered": function(eventObj, dataObj) {
							html.showWait(false);
						}
					}
				}).render();
	        	this._fusionCharts.push(fusionChart);
			},this);
		},

		_deleteChartNodes: function() {
			// summary: delete chart nodes and dispose FusionCharts internal data
			html.destroyChildren(this.domNode);
			this._disposeCharts();
		},

		_disposeCharts: function() {
			// summary: dispose FusionCharts internal data
			_.forEach(this._fusionCharts, function(fusionChart) {
				fusionChart.dispose();
			});
			this._fusionCharts = null;
		},

		destroy: function(/*Boolean*/preserveDom) {
			this._disposeCharts();
			this.inherited(arguments);
		},

		refreshCharts: function() {
			// summary: refresh charts based on the current metric and chart type
			this._renderCharts();
		},

		_setMetricKeyAttr: function(/*String*/value) {
			this._set("metricKey", value);
			this.refreshCharts();
		},

		_setSettingsAttr: function(/*String*/value) {
			this._set("settings", value);
			this.refreshCharts();
		}
	});

	// global variables
	Widget.DEFAULT_SETTINGS = DEFAULT_SETTINGS;

	return Widget;
});